import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConnectServerService } from '../../../services/connect-server.service';
import { Connect } from '../../../classes/connect';
import { ApiResponse } from '../../../interfaces/api-response';
import { PopupDialogService } from '../../../services/popup-dialog.service';

interface User {
  id: number;
  name: string;
  email: string;
}

interface Permission {
  idcomponent: number;
  component_name: string;
  function_name: string;
  idfunction: number;
  authorization: number;
}

interface Functionality {
  id: number;
  name: string;
  description: string;
}

@Component({
  selector: 'app-permissions',
  imports: [ReactiveFormsModule],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss'
})
export class PermissionsComponent implements OnInit {
  permissionsList: Functionality[] = [];

  permissionsForm: FormGroup = this.fb.group({
    authorizations: this.fb.array([])
  });

  constructor(
    private fb: FormBuilder,
    private connectServerService: ConnectServerService,
    private popupService: PopupDialogService
  ) { }

  ngOnInit(): void {
    this.connectServerService.getRequest('listFunctionalities', {}, Connect.urlServerLaraApi)
      .subscribe((val: Functionality[]) => {
        this.permissionsList = val;
        this.popolateArray();
      });
  }

  get authorizations(): FormArray {
    return this.permissionsForm.get('authorizations') as FormArray;
  }

  getPermissionsControls(index: number): FormArray {
    return this.authorizations.at(index).get('permissions') as FormArray;
  }

  private createAuthorizationsField(content: { user: User; permissions: Permission[] }): FormGroup {
    return this.fb.group({
      user: this.createUserForm(content.user),
      permissions: this.addPermissionsArray(content.permissions)
    });
  }

  private createPermissionsField(permission: Permission): FormGroup {
    return this.fb.group({
      idcomponent: [permission.idcomponent],
      component_name: [permission.component_name],
      function_name: [permission.function_name],
      idfunction: [permission.idfunction],
      authorization: [permission.authorization, Validators.required]
    });
  }

  private createUserForm(user: User): FormGroup {
    return this.fb.group({
      id: [user.id],
      name: [user.name],
      email: [user.email]
    });
  }

  private addPermissionsArray(permissions: Permission[]): FormArray {
    const permissionArray = this.fb.array([]) as FormArray;
    permissions.forEach((item: Permission) => {
      permissionArray.push(this.createPermissionsField(item));
    });
    return permissionArray;
  }

  private popolateArray(): void {
    this.authorizations.clear();
    this.connectServerService.getRequest('listUsersFunctionalitiesPermissions', {}, Connect.urlServerLaraApi)
      .subscribe((val: { user: User; permissions: Permission[] }[]) => {
        val.forEach(element => {
          this.authorizations.push(this.createAuthorizationsField(element));
        });
      });
  }

  save(): void {
    this.authorizations.controls.forEach((_, index) => {
      this.getPermissionsControls(index).controls.forEach(element => {
        if (element.get('authorization')?.value == true) {
          element.get('authorization')?.setValue(1);
        } else if (element.get('authorization')?.value == false) {
          element.get('authorization')?.setValue(0);
        }
      });
    });

    const permissions = this.permissionsForm.getRawValue().authorizations;
    this.connectServerService.postRequest<ApiResponse<{}>>('permissionsFunctionsUsers', {
      listPermissions: permissions
    }, Connect.urlServerLaraApi).subscribe((esito: ApiResponse<{}>) => {
      this.popupService.popupDialog(esito);
      this.popolateArray();
    });
  }
}
